import { InputAdornment, TextField } from '@material-ui/core'
import { Check as CheckIcon } from '@material-ui/icons'
import clsx from 'clsx'
import React from 'react'
import { FormTextFieldProps } from './Type'
import { useStyles } from './Style'

const FormTextField: React.FC<FormTextFieldProps> = ({
  className,
  updated,
  testid,
  helperText,
  InputProps = {},
  ...props
}): React.ReactElement => {
  const classes = useStyles()
  const { endAdornment, ...PropsForInput } = InputProps

  return (
    <TextField
      variant="outlined"
      data-testid={testid}
      helperText={helperText || ' '}
      FormHelperTextProps={{
        className: classes.helperText,
      }}
      {...{
        ...props,
        InputProps: {
          endAdornment: (
            <>
              <InputAdornment position="end" className="field-check">
                <CheckIcon />
              </InputAdornment>
              {endAdornment}
            </>
          ),
          ...PropsForInput,
        },
      }}
      className={clsx(classes.field, updated && classes['field-updated'], className)}
    />
  )
}

export default FormTextField
